import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=770479f4&scoped=true&"
import script from "./Reorder.vue?vue&type=script&lang=js&"
export * from "./Reorder.vue?vue&type=script&lang=js&"
import style0 from "./Reorder.vue?vue&type=style&index=0&id=770479f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770479f4",
  null
  
)

export default component.exports